import { createContext } from 'react';
import { IApplicationContext } from '../../types/application';

export const AppContext = createContext<IApplicationContext>({} as IApplicationContext);
